module.exports = [
  // type
  require('./BigNumber'),

  // construction function
  require('./function/bignumber')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/type/bignumber/index.js
// module id = 1289
// module chunks = 0